import { useState, Dispatch, SetStateAction } from 'react';
import { DialogProps } from '@material-ui/core';
import SignUpBaseForm from './SignUpForm/SignUpBaseForm';
import SignUpUserForm from './SignUpForm/SignUpUserForm';
import { i18n } from 'lib/i18n';

interface SignUpFormProps extends DialogProps {
	invitationToken?: string;
	postFromSignUp?: (success: boolean) => void;
	defaulteEmail?: string;
	setIsForgotPass: (v: boolean) => void;
}

interface INextStepProps extends Partial<SignUpFormProps> {
	setIsNextStep: Dispatch<SetStateAction<boolean>>;
}

const NextStep = ({ onClose, postFromSignUp, setIsNextStep }: INextStepProps) => {
	const [isUserSignUp, setIsUserSignUp] = useState(true);

	return isUserSignUp ? (
		<SignUpUserForm
			onClose={onClose}
			postFromSignUp={postFromSignUp}
			setIsNextStep={setIsNextStep}
			setIsUserSignUp={setIsUserSignUp}
		/>
	) : (
		<>{i18n.loginDialog.organizationSignUpPage}</>
	);
};

const SignUpForm = ({ onClose, postFromSignUp, defaulteEmail, setIsForgotPass, invitationToken }: SignUpFormProps) => {
	const [isNextStep, setIsNextStep] = useState(false);

	return isNextStep ? (
		<NextStep onClose={onClose} postFromSignUp={postFromSignUp} setIsNextStep={setIsNextStep} />
	) : (
		<SignUpBaseForm
			invitationToken={invitationToken}
			setNextStep={setIsNextStep}
			defaulteEmail={defaulteEmail}
			setIsForgotPass={setIsForgotPass}
		/>
	);
};

export default SignUpForm;
